import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AccountService } from "src/app/dashboard/services/account.service";
import { ProfileService } from "src/app/dashboard/services/profile.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-withdraw",
  templateUrl: "./withdraw.component.html",
  styleUrls: ["./withdraw.component.css"]
})
export class WithdrawComponent implements OnInit {
  localWithdrawManualForm: FormGroup;
  bitcoinWithdrawForm: FormGroup;
  selectedTab: number = 1;
  tradeAccounts: { login: number; type: string } = null;
  isLocalWithdrawLoading: boolean = false;

  bankaccounts: {
    bankname: string;
    account_holder_name: string;
    country: string;
    account_number: string;
    ifsc_code: string;
    swift_code?: string;
    bank_details?: string;
  }[] = [];

  constructor(private account: AccountService, private profile: ProfileService) { }
  ngOnInit() {
    this.localWithdrawManualForm = new FormGroup({
      login: new FormControl(null, [Validators.required]),
      bankDetails: new FormControl(null, [
        Validators.required,
        Validators.maxLength(250)
      ]),
      amount: new FormControl(null, [Validators.required, Validators.min(1)]),
      bankaccount: new FormControl(null, [Validators.required])
    });

    this.bitcoinWithdrawForm = new FormGroup({
      login: new FormControl(null, [Validators.required]),
      amount: new FormControl(null, [Validators.required])
    });

    this.localWithdrawManualForm.get("bankaccount").valueChanges.subscribe((value: {
      bankname: string;
      account_holder_name: string;
      country: string;
      account_number: string;
      ifsc_code: string;
      swift_code?: string;
      bank_details?: string;
    }) => {
      this.localWithdrawManualForm.patchValue({ bankDetails: this.displayObjectAsList(value) });
    });

    this.getAccounts();
    this.getBankaccounts();
  }

  displayObjectAsList(object: any) {
    let list: string = '';
    for (let key in object) {
      if (object.hasOwnProperty(key) && object[key] !== null) {
        let formattedKey = key.replace(/_/g, ' ');
        list += `${formattedKey}: ${object[key]}\n`;
      }
    }

    return list;
  }

  getAccounts() {
    this.account.getLiveAccountsList().subscribe(response => {
      if (response.request_status) {
        this.tradeAccounts = response.data;
      }
    });
  }

  selectTab(tab: number) {
    this.selectedTab = tab;
  }

  onLocalWithdraw() {
    this.isLocalWithdrawLoading = true;
    let formData: { login: number; amount: number; bank_detail: string } = {
      login: this.localWithdrawManualForm.value.login.login,
      amount: this.localWithdrawManualForm.value.amount,
      bank_detail: this.localWithdrawManualForm.value.bankDetails
    };

    this.account.withdrawManualLocal(formData).subscribe(
      response => {
        this.isLocalWithdrawLoading = false;
        if (response.request_status) {
          Swal.fire("Manual Withdraw Requested", "", "success");
          this.localWithdrawManualForm.reset();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      error => {
        this.isLocalWithdrawLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  getBankaccounts() {
    this.profile.getUserBankaccounts().subscribe((response) => {
      this.bankaccounts = response.data;
    });
  }
}
